var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background"},[_c('span',{staticClass:"rating",style:({width: (_vm.score / 5 * 100).toFixed(2) + '%'})})])}
var staticRenderFns = []

export { render, staticRenderFns }